!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.Loading = t() : e.Loading = t();
}(window, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "/", n(n.s = 15);
  }([function (e, t) {
    e.exports = function (e) {
      var t = "undefined" != typeof window && window.location;
      if (!t) throw new Error("fixUrls requires window.location");
      if (!e || "string" != typeof e) return e;
      var n = t.protocol + "//" + t.host,
          r = n + t.pathname.replace(/\/[^\/]*$/, "/");
      return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
        var o,
            i = t.trim().replace(/^"(.*)"$/, function (e, t) {
          return t;
        }).replace(/^'(.*)'$/, function (e, t) {
          return t;
        });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(i) ? e : (o = 0 === i.indexOf("//") ? i : 0 === i.indexOf("/") ? n + i : r + i.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
      });
    };
  }, function (e, t, n) {
    var r = {},
        o = function (e) {
      var t;
      return function () {
        return void 0 === t && (t = e.apply(this, arguments)), t;
      };
    }(function () {
      return window && document && document.all && !window.atob;
    }),
        i = function (e) {
      var t = {};
      return function (e) {
        if ("function" == typeof e) return e();

        if (void 0 === t[e]) {
          var n = function (e) {
            return document.querySelector(e);
          }.call(this, e);

          if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
            n = n.contentDocument.head;
          } catch (e) {
            n = null;
          }
          t[e] = n;
        }

        return t[e];
      };
    }(),
        a = null,
        u = 0,
        c = [],
        l = n(0);

    function s(e, t) {
      for (var n = 0; n < e.length; n++) {
        var o = e[n],
            i = r[o.id];

        if (i) {
          i.refs++;

          for (var a = 0; a < i.parts.length; a++) {
            i.parts[a](o.parts[a]);
          }

          for (; a < o.parts.length; a++) {
            i.parts.push(h(o.parts[a], t));
          }
        } else {
          var u = [];

          for (a = 0; a < o.parts.length; a++) {
            u.push(h(o.parts[a], t));
          }

          r[o.id] = {
            id: o.id,
            refs: 1,
            parts: u
          };
        }
      }
    }

    function f(e, t) {
      for (var n = [], r = {}, o = 0; o < e.length; o++) {
        var i = e[o],
            a = t.base ? i[0] + t.base : i[0],
            u = {
          css: i[1],
          media: i[2],
          sourceMap: i[3]
        };
        r[a] ? r[a].parts.push(u) : n.push(r[a] = {
          id: a,
          parts: [u]
        });
      }

      return n;
    }

    function p(e, t) {
      var n = i(e.insertInto);
      if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var r = c[c.length - 1];
      if ("top" === e.insertAt) r ? r.nextSibling ? n.insertBefore(t, r.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), c.push(t);else if ("bottom" === e.insertAt) n.appendChild(t);else {
        if ("object" != typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var o = i(e.insertInto + " " + e.insertAt.before);
        n.insertBefore(t, o);
      }
    }

    function d(e) {
      if (null === e.parentNode) return !1;
      e.parentNode.removeChild(e);
      var t = c.indexOf(e);
      t >= 0 && c.splice(t, 1);
    }

    function y(e) {
      var t = document.createElement("style");
      return void 0 === e.attrs.type && (e.attrs.type = "text/css"), b(t, e.attrs), p(e, t), t;
    }

    function b(e, t) {
      Object.keys(t).forEach(function (n) {
        e.setAttribute(n, t[n]);
      });
    }

    function h(e, t) {
      var n, r, o, i;

      if (t.transform && e.css) {
        if (!(i = t.transform(e.css))) return function () {};
        e.css = i;
      }

      if (t.singleton) {
        var c = u++;
        n = a || (a = y(t)), r = m.bind(null, n, c, !1), o = m.bind(null, n, c, !0);
      } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n = function (e) {
        var t = document.createElement("link");
        return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", b(t, e.attrs), p(e, t), t;
      }(t), r = function (e, t, n) {
        var r = n.css,
            o = n.sourceMap,
            i = void 0 === t.convertToAbsoluteUrls && o;
        (t.convertToAbsoluteUrls || i) && (r = l(r));
        o && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
        var a = new Blob([r], {
          type: "text/css"
        }),
            u = e.href;
        e.href = URL.createObjectURL(a), u && URL.revokeObjectURL(u);
      }.bind(null, n, t), o = function o() {
        d(n), n.href && URL.revokeObjectURL(n.href);
      }) : (n = y(t), r = function (e, t) {
        var n = t.css,
            r = t.media;
        r && e.setAttribute("media", r);
        if (e.styleSheet) e.styleSheet.cssText = n;else {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }

          e.appendChild(document.createTextNode(n));
        }
      }.bind(null, n), o = function o() {
        d(n);
      });

      return r(e), function (t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          r(e = t);
        } else o();
      };
    }

    e.exports = function (e, t) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (t = t || {}).attrs = "object" == typeof t.attrs ? t.attrs : {}, t.singleton || "boolean" == typeof t.singleton || (t.singleton = o()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
      var n = f(e, t);
      return s(n, t), function (e) {
        for (var o = [], i = 0; i < n.length; i++) {
          var a = n[i];
          (u = r[a.id]).refs--, o.push(u);
        }

        e && s(f(e, t), t);

        for (i = 0; i < o.length; i++) {
          var u;

          if (0 === (u = o[i]).refs) {
            for (var c = 0; c < u.parts.length; c++) {
              u.parts[c]();
            }

            delete r[u.id];
          }
        }
      };
    };

    var v = function () {
      var e = [];
      return function (t, n) {
        return e[t] = n, e.filter(Boolean).join("\n");
      };
    }();

    function m(e, t, n, r) {
      var o = n ? "" : r.css;
      if (e.styleSheet) e.styleSheet.cssText = v(t, o);else {
        var i = document.createTextNode(o),
            a = e.childNodes;
        a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(i, a[t]) : e.appendChild(i);
      }
    }
  }, function (e, t) {
    e.exports = function (e) {
      var t = [];
      return t.toString = function () {
        return this.map(function (t) {
          var n = function (e, t) {
            var n = e[1] || "",
                r = e[3];
            if (!r) return n;

            if (t && "function" == typeof btoa) {
              var o = function (e) {
                return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
              }(r),
                  i = r.sources.map(function (e) {
                return "/*# sourceURL=" + r.sourceRoot + e + " */";
              });

              return [n].concat(i).concat([o]).join("\n");
            }

            return [n].join("\n");
          }(t, e);

          return t[2] ? "@media " + t[2] + "{" + n + "}" : n;
        }).join("");
      }, t.i = function (e, n) {
        "string" == typeof e && (e = [[null, e, ""]]);

        for (var r = {}, o = 0; o < this.length; o++) {
          var i = this[o][0];
          "number" == typeof i && (r[i] = !0);
        }

        for (o = 0; o < e.length; o++) {
          var a = e[o];
          "number" == typeof a[0] && r[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), t.push(a));
        }
      }, t;
    };
  }, function (e, t, n) {
    (e.exports = n(2)(!1)).push([e.i, '.loading-background {\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 99;\n  cursor: progress;\n}\n.loading-background .loading-bar {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: 50px;\n  height: 50px;\n  transform: translate(-50%, -50%);\n}\n.loading-background .loading-bar .loading-circle-1,\n.loading-background .loading-bar .loading-circle-2 {\n  content: " ";\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background-color: #e74c3c;\n  opacity: 0.6;\n  position: absolute;\n  top: 0;\n  left: 0;\n  -webkit-animation: sk-bounce 2s infinite ease-in-out;\n  animation: sk-bounce 2s infinite ease-in-out;\n}\n.loading-background .loading-bar .loading-circle-2 {\n  -webkit-animation-delay: -1s;\n  animation-delay: -1s;\n}\n\n@-webkit-keyframes sk-bounce {\n  0%,\n  100% {\n    -webkit-transform: scale(0);\n  }\n  50% {\n    -webkit-transform: scale(1);\n  }\n}\n@keyframes sk-bounce {\n  0%,\n  100% {\n    transform: scale(0);\n    -webkit-transform: scale(0);\n  }\n  50% {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n  }\n}\n', ""]);
  }, function (e, t, n) {
    var r = n(3);
    "string" == typeof r && (r = [[e.i, r, ""]]);
    var o = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(1)(r, o);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    "use strict";

    var r = n(5);

    function o() {}

    e.exports = function () {
      function e(e, t, n, o, i, a) {
        if (a !== r) {
          var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw u.name = "Invariant Violation", u;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return n.checkPropTypes = o, n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    e.exports = n(6)();
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return function () {
        return e;
      };
    }

    var o = function o() {};

    o.thatReturns = r, o.thatReturnsFalse = r(!1), o.thatReturnsTrue = r(!0), o.thatReturnsNull = r(null), o.thatReturnsThis = function () {
      return this;
    }, o.thatReturnsArgument = function (e) {
      return e;
    }, e.exports = o;
  }, function (e, t, n) {
    "use strict";

    e.exports = {};
  }, function (e, t, n) {
    "use strict";

    var r = function r(e) {};

    e.exports = function (e, t, n, o, i, a, u, c) {
      if (r(t), !e) {
        var l;
        if (void 0 === t) l = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var s = [n, o, i, a, u, c],
              f = 0;
          (l = new Error(t.replace(/%s/g, function () {
            return s[f++];
          }))).name = "Invariant Violation";
        }
        throw l.framesToPop = 1, l;
      }
    };
  }, function (e, t, n) {
    "use strict";
    /*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    */

    var r = Object.getOwnPropertySymbols,
        o = Object.prototype.hasOwnProperty,
        i = Object.prototype.propertyIsEnumerable;
    e.exports = function () {
      try {
        if (!Object.assign) return !1;
        var e = new String("abc");
        if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

        for (var t = {}, n = 0; n < 10; n++) {
          t["_" + String.fromCharCode(n)] = n;
        }

        if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
          return t[e];
        }).join("")) return !1;
        var r = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (e) {
          r[e] = e;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
      } catch (e) {
        return !1;
      }
    }() ? Object.assign : function (e, t) {
      for (var n, a, u = function (e) {
        if (null === e || void 0 === e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }(e), c = 1; c < arguments.length; c++) {
        for (var l in n = Object(arguments[c])) {
          o.call(n, l) && (u[l] = n[l]);
        }

        if (r) {
          a = r(n);

          for (var s = 0; s < a.length; s++) {
            i.call(n, a[s]) && (u[a[s]] = n[a[s]]);
          }
        }
      }

      return u;
    };
  }, function (e, t, n) {
    "use strict";
    /** @license React v16.4.1
     * react.production.min.js
     *
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    var r = n(11),
        o = n(10),
        i = n(9),
        a = n(8),
        u = "function" == typeof Symbol && Symbol.for,
        c = u ? Symbol.for("react.element") : 60103,
        l = u ? Symbol.for("react.portal") : 60106,
        s = u ? Symbol.for("react.fragment") : 60107,
        f = u ? Symbol.for("react.strict_mode") : 60108,
        p = u ? Symbol.for("react.profiler") : 60114,
        d = u ? Symbol.for("react.provider") : 60109,
        y = u ? Symbol.for("react.context") : 60110,
        b = u ? Symbol.for("react.async_mode") : 60111,
        h = u ? Symbol.for("react.forward_ref") : 60112;
    u && Symbol.for("react.timeout");
    var v = "function" == typeof Symbol && Symbol.iterator;

    function m(e) {
      for (var t = arguments.length - 1, n = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, r = 0; r < t; r++) {
        n += "&args[]=" + encodeURIComponent(arguments[r + 1]);
      }

      o(!1, "Minified React error #" + e + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", n);
    }

    var g = {
      isMounted: function isMounted() {
        return !1;
      },
      enqueueForceUpdate: function enqueueForceUpdate() {},
      enqueueReplaceState: function enqueueReplaceState() {},
      enqueueSetState: function enqueueSetState() {}
    };

    function w(e, t, n) {
      this.props = e, this.context = t, this.refs = i, this.updater = n || g;
    }

    function O() {}

    function j(e, t, n) {
      this.props = e, this.context = t, this.refs = i, this.updater = n || g;
    }

    w.prototype.isReactComponent = {}, w.prototype.setState = function (e, t) {
      "object" != typeof e && "function" != typeof e && null != e && m("85"), this.updater.enqueueSetState(this, e, t, "setState");
    }, w.prototype.forceUpdate = function (e) {
      this.updater.enqueueForceUpdate(this, e, "forceUpdate");
    }, O.prototype = w.prototype;
    var k = j.prototype = new O();
    k.constructor = j, r(k, w.prototype), k.isPureReactComponent = !0;
    var _ = {
      current: null
    },
        x = Object.prototype.hasOwnProperty,
        S = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };

    function R(e, t, n) {
      var r = void 0,
          o = {},
          i = null,
          a = null;
      if (null != t) for (r in void 0 !== t.ref && (a = t.ref), void 0 !== t.key && (i = "" + t.key), t) {
        x.call(t, r) && !S.hasOwnProperty(r) && (o[r] = t[r]);
      }
      var u = arguments.length - 2;
      if (1 === u) o.children = n;else if (1 < u) {
        for (var l = Array(u), s = 0; s < u; s++) {
          l[s] = arguments[s + 2];
        }

        o.children = l;
      }
      if (e && e.defaultProps) for (r in u = e.defaultProps) {
        void 0 === o[r] && (o[r] = u[r]);
      }
      return {
        $$typeof: c,
        type: e,
        key: i,
        ref: a,
        props: o,
        _owner: _.current
      };
    }

    function E(e) {
      return "object" == typeof e && null !== e && e.$$typeof === c;
    }

    var P = /\/+/g,
        C = [];

    function T(e, t, n, r) {
      if (C.length) {
        var o = C.pop();
        return o.result = e, o.keyPrefix = t, o.func = n, o.context = r, o.count = 0, o;
      }

      return {
        result: e,
        keyPrefix: t,
        func: n,
        context: r,
        count: 0
      };
    }

    function U(e) {
      e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, 10 > C.length && C.push(e);
    }

    function A(e, t, n, r) {
      var o = typeof e;
      "undefined" !== o && "boolean" !== o || (e = null);
      var i = !1;
      if (null === e) i = !0;else switch (o) {
        case "string":
        case "number":
          i = !0;
          break;

        case "object":
          switch (e.$$typeof) {
            case c:
            case l:
              i = !0;
          }

      }
      if (i) return n(r, e, "" === t ? "." + L(e, 0) : t), 1;
      if (i = 0, t = "" === t ? "." : t + ":", Array.isArray(e)) for (var a = 0; a < e.length; a++) {
        var u = t + L(o = e[a], a);
        i += A(o, u, n, r);
      } else if (null === e || void 0 === e ? u = null : u = "function" == typeof (u = v && e[v] || e["@@iterator"]) ? u : null, "function" == typeof u) for (e = u.call(e), a = 0; !(o = e.next()).done;) {
        i += A(o = o.value, u = t + L(o, a++), n, r);
      } else "object" === o && m("31", "[object Object]" === (n = "" + e) ? "object with keys {" + Object.keys(e).join(", ") + "}" : n, "");
      return i;
    }

    function L(e, t) {
      return "object" == typeof e && null !== e && null != e.key ? function (e) {
        var t = {
          "=": "=0",
          ":": "=2"
        };
        return "$" + ("" + e).replace(/[=:]/g, function (e) {
          return t[e];
        });
      }(e.key) : t.toString(36);
    }

    function $(e, t) {
      e.func.call(e.context, t, e.count++);
    }

    function I(e, t, n) {
      var r = e.result,
          o = e.keyPrefix;
      e = e.func.call(e.context, t, e.count++), Array.isArray(e) ? M(e, r, n, a.thatReturnsArgument) : null != e && (E(e) && (t = o + (!e.key || t && t.key === e.key ? "" : ("" + e.key).replace(P, "$&/") + "/") + n, e = {
        $$typeof: c,
        type: e.type,
        key: t,
        ref: e.ref,
        props: e.props,
        _owner: e._owner
      }), r.push(e));
    }

    function M(e, t, n, r, o) {
      var i = "";
      null != n && (i = ("" + n).replace(P, "$&/") + "/"), t = T(t, i, r, o), null == e || A(e, "", I, t), U(t);
    }

    var N = {
      Children: {
        map: function map(e, t, n) {
          if (null == e) return e;
          var r = [];
          return M(e, r, null, t, n), r;
        },
        forEach: function forEach(e, t, n) {
          if (null == e) return e;
          t = T(null, null, t, n), null == e || A(e, "", $, t), U(t);
        },
        count: function count(e) {
          return null == e ? 0 : A(e, "", a.thatReturnsNull, null);
        },
        toArray: function toArray(e) {
          var t = [];
          return M(e, t, null, a.thatReturnsArgument), t;
        },
        only: function only(e) {
          return E(e) || m("143"), e;
        }
      },
      createRef: function createRef() {
        return {
          current: null
        };
      },
      Component: w,
      PureComponent: j,
      createContext: function createContext(e, t) {
        return void 0 === t && (t = null), (e = {
          $$typeof: y,
          _calculateChangedBits: t,
          _defaultValue: e,
          _currentValue: e,
          _currentValue2: e,
          _changedBits: 0,
          _changedBits2: 0,
          Provider: null,
          Consumer: null
        }).Provider = {
          $$typeof: d,
          _context: e
        }, e.Consumer = e;
      },
      forwardRef: function forwardRef(e) {
        return {
          $$typeof: h,
          render: e
        };
      },
      Fragment: s,
      StrictMode: f,
      unstable_AsyncMode: b,
      unstable_Profiler: p,
      createElement: R,
      cloneElement: function cloneElement(e, t, n) {
        (null === e || void 0 === e) && m("267", e);
        var o = void 0,
            i = r({}, e.props),
            a = e.key,
            u = e.ref,
            l = e._owner;

        if (null != t) {
          void 0 !== t.ref && (u = t.ref, l = _.current), void 0 !== t.key && (a = "" + t.key);
          var s = void 0;

          for (o in e.type && e.type.defaultProps && (s = e.type.defaultProps), t) {
            x.call(t, o) && !S.hasOwnProperty(o) && (i[o] = void 0 === t[o] && void 0 !== s ? s[o] : t[o]);
          }
        }

        if (1 === (o = arguments.length - 2)) i.children = n;else if (1 < o) {
          s = Array(o);

          for (var f = 0; f < o; f++) {
            s[f] = arguments[f + 2];
          }

          i.children = s;
        }
        return {
          $$typeof: c,
          type: e.type,
          key: a,
          ref: u,
          props: i,
          _owner: l
        };
      },
      createFactory: function createFactory(e) {
        var t = R.bind(null, e);
        return t.type = e, t;
      },
      isValidElement: E,
      version: "16.4.1",
      __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
        ReactCurrentOwner: _,
        assign: r
      }
    },
        B = {
      default: N
    },
        q = B && N || B;
    e.exports = q.default ? q.default : q;
  }, function (e, t, n) {
    "use strict";

    e.exports = n(12);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        o = a(n(13)),
        i = a(n(7));

    function a(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    n(4);

    var u = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, o.default.Component), r(t, [{
        key: "render",
        value: function value() {
          var e = {
            background: this.props.background
          },
              t = {
            background: this.props.loaderColor
          };
          return this.props.loading ? o.default.createElement("div", {
            className: "loading-background",
            style: e
          }, o.default.createElement("div", {
            className: "loading-bar"
          }, o.default.createElement("div", {
            className: "loading-circle-1",
            style: t
          }), o.default.createElement("div", {
            className: "loading-circle-2",
            style: t
          }))) : null;
        }
      }]), t;
    }();

    u.defaultProps = {
      loading: !1,
      background: "rgba(236, 240, 241, 0.7)",
      loaderColor: "#e74c3c"
    }, u.propTypes = {
      loading: i.default.bool,
      background: i.default.string,
      loaderColor: i.default.string
    }, t.default = u;
  }, function (e, t, n) {
    e.exports = n(14);
  }]);
});